<div (click)="openDatePicker()" class="date-picker-container">
  <mat-label class="date-picker-container__label" *ngIf="title">{{ translatedTitle }}</mat-label>
  <mat-form-field appearance="fill">
    <input matInput [matDatepicker]="picker" [formControl]="dateValue" [max]="disableFutureDates ? maxDate : null" readonly>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker [startAt]="maxDate"></mat-datepicker>
  </mat-form-field>
</div>
